import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { registerUser } from '../../actions/authActions';

class SignUp extends Component {
    constructor() {
        super();
        this.state = {
            name:      '',
            phone:     '',
            email:     '',
            gender:    'M',
            address:   '',
            password:  '',
            password2: '',
            terms:     false,
            errors:    {},
        };
    }

    componentDidMount() {
        if (this.props.auth.isAuthenticated) {
            this.props.history.push('/doctor-home');
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.errors) {
            this.setState({ errors: nextProps.errors });
        }
    }

    onChange = (e) => {
        var err = this.state.errors;
        delete err[e.target.name];
        this.setState({ [e.target.name]: e.target.value });
    };

    onSubmit = (e) => {
        e.preventDefault();
        const newUser = {
            name:      this.state.name,
            phone:     this.state.phone,
            email:     this.state.email,
            gender:    this.state.gender,
            address:   this.state.address,
            password:  this.state.password,
            password2: this.state.password2,
            terms:     this.state.terms,
            type:      'doctor',
        };
        this.props.registerUser(newUser, this.props.history, '/login');
    };

    termsClick = () => {
        this.setState({ terms: !this.state.terms });
    };

    render() {
        const { errors } = this.state;

        // Shared styles matching Login.js exactly so the two pages feel
        // like one product. Pulled inline so this file is self-contained.
        const inputStyle = {
            width: "100%", height: 44, padding: "0 14px",
            background: "#0f3538", border: "1px solid rgba(46,170,187,0.3)",
            borderRadius: 8, color: "#e2eef2", fontSize: 14, outline: "none",
            transition: "border-color 0.2s, box-shadow 0.2s",
        };
        const inputErrorStyle = {
            ...inputStyle,
            border: "1px solid rgba(231,76,60,0.6)",
            background: "rgba(231,76,60,0.06)",
        };
        const textareaStyle = {
            ...inputStyle, height: 70, padding: "10px 14px", resize: "vertical",
            fontFamily: "inherit",
        };
        const labelStyle = {
            color: "#89a8c0", fontSize: 11, fontWeight: 600,
            textTransform: "uppercase", letterSpacing: "0.5px",
            marginBottom: 6, display: "block",
        };
        const helpTextStyle = {
            color: "#5a8fa8", fontSize: 11, marginTop: 4,
        };
        const radioWrapStyle = {
            display: "inline-flex", alignItems: "center", gap: 6,
            padding: "8px 16px", marginRight: 10,
            background: "#0f3538", border: "1px solid rgba(46,170,187,0.3)",
            borderRadius: 8, cursor: "pointer",
            color: "#e2eef2", fontSize: 13, fontWeight: 500,
        };
        const radioWrapActiveStyle = {
            ...radioWrapStyle,
            background: "rgba(46,170,187,0.18)",
            borderColor: "#2eaabb",
            color: "#fff",
        };

        return (
            <div style={{
                minHeight: "100vh", width: "100%",
                background:
                    "radial-gradient(circle at 50% 35%, rgba(46,170,187,0.12) 0%, rgba(0,0,0,0) 60%), " +
                    "linear-gradient(180deg, #041415 0%, #072224 70%, #041415 100%)",
                display: "flex", flexDirection: "column",
            }}>
                {/* Header */}
                <header style={{
                    display: "flex", alignItems: "center", justifyContent: "space-between",
                    padding: "14px 28px",
                    background: "rgba(7,34,36,0.7)",
                    borderBottom: "1px solid rgba(46,170,187,0.18)",
                    backdropFilter: "blur(6px)",
                }}>
                    <a href="/" style={{ display: "flex", alignItems: "center", gap: 10, textDecoration: "none" }}>
                        <img src="dist/img/logo.png" alt="brand" style={{ height: 30 }} />
                        <span style={{ color: "#e2eef2", fontWeight: 700, fontSize: 17, letterSpacing: "0.4px" }}>
                            Biocalculus
                        </span>
                    </a>
                    <div style={{ display: "flex", gap: 10 }}>
                        <a href="/login" style={{
                            padding: "8px 16px", fontSize: 12, fontWeight: 600,
                            background: "transparent", border: "1px solid #2eaabb",
                            borderRadius: 20, color: "#2eaabb", textDecoration: "none",
                            transition: "all 0.15s",
                        }}>Sign In</a>
                    </div>
                </header>

                {/* Card */}
                <div style={{
                    flex: 1, display: "flex",
                    alignItems: "center", justifyContent: "center",
                    padding: "40px 16px",
                }}>
                    <div style={{
                        width: "100%", maxWidth: 520,
                        borderRadius: 16, overflow: "hidden",
                        background: "linear-gradient(160deg,#0e2a2e 0%,#0a1f22 100%)",
                        boxShadow: "0 24px 60px rgba(0,0,0,0.6), 0 0 0 1px rgba(46,170,187,0.18)",
                    }}>
                        {/* Card header */}
                        <div style={{
                            background: "linear-gradient(90deg,#0c2e32 0%,#0f3538 100%)",
                            padding: "22px 26px",
                            borderBottom: "1px solid rgba(46,170,187,0.18)",
                            textAlign: "center",
                        }}>
                            <div style={{
                                width: 56, height: 56, borderRadius: 14, margin: "0 auto 12px",
                                background: "linear-gradient(135deg,rgba(46,170,187,0.3),rgba(46,170,187,0.08))",
                                border: "1px solid rgba(46,170,187,0.4)",
                                display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24,
                            }}>🩺</div>
                            <div style={{ color: "#e2eef2", fontWeight: 700, fontSize: 18 }}>Sign up as Doctor</div>
                            <div style={{ color: "#4a8a9a", fontSize: 12, marginTop: 4 }}>
                                Enter your details below
                            </div>
                        </div>

                        {/* Card body */}
                        <form method="post" id="signup_form" role="form" onSubmit={this.onSubmit}
                              style={{ padding: "24px 26px", background: "#0a1f22" }}>

                            {/* General error banner */}
                            {errors.exists && (
                                <div style={{
                                    marginBottom: 16, padding: "10px 14px",
                                    borderRadius: 8,
                                    background: "rgba(231,76,60,0.12)",
                                    border: "1px solid rgba(231,76,60,0.4)",
                                    color: "#ff6b6b",
                                    fontSize: 12, fontWeight: 500,
                                    display: "flex", alignItems: "center", gap: 8,
                                }}>
                                    <span>⚠️</span><span>{errors.exists}</span>
                                </div>
                            )}

                            {/* Name */}
                            <label style={labelStyle}>👤 Name</label>
                            <input
                                type="text" name="name" required id="name"
                                onChange={this.onChange} value={this.state.name}
                                placeholder="Enter your full name"
                                style={{ ...(errors.name ? inputErrorStyle : inputStyle), marginBottom: 16 }}
                            />

                            {/* Phone */}
                            <label style={labelStyle}>📱 Phone Number</label>
                            <input
                                type="tel" name="phone" required id="phone"
                                inputMode="numeric" pattern="[0-9]*"
                                onChange={this.onChange} value={this.state.phone}
                                placeholder="10-digit phone number"
                                style={{ ...(errors.phone ? inputErrorStyle : inputStyle), marginBottom: 16 }}
                            />

                            {/* Email */}
                            <label style={labelStyle}>📧 Email Address</label>
                            <input
                                type="email" name="email" required id="email"
                                onChange={this.onChange} value={this.state.email}
                                placeholder="you@example.com"
                                style={{ ...(errors.email ? inputErrorStyle : inputStyle), marginBottom: 16 }}
                            />

                            {/* Gender */}
                            <label style={labelStyle}>⚧ Gender</label>
                            <div style={{ display: "flex", marginBottom: 16 }}>
                                <label style={this.state.gender === "M" ? radioWrapActiveStyle : radioWrapStyle}>
                                    <input
                                        type="radio" name="gender" value="M"
                                        checked={this.state.gender === "M"}
                                        onChange={this.onChange}
                                        style={{ accentColor: "#2eaabb", margin: 0 }}
                                    />
                                    Male
                                </label>
                                <label style={this.state.gender === "F" ? radioWrapActiveStyle : radioWrapStyle}>
                                    <input
                                        type="radio" name="gender" value="F"
                                        checked={this.state.gender === "F"}
                                        onChange={this.onChange}
                                        style={{ accentColor: "#2eaabb", margin: 0 }}
                                    />
                                    Female
                                </label>
                            </div>

                            {/* Address */}
                            <label style={labelStyle}>📍 Address</label>
                            <textarea
                                name="address" id="address"
                                onChange={this.onChange} value={this.state.address}
                                placeholder="Hospital / clinic address"
                                style={{ ...textareaStyle, marginBottom: 16 }}
                            />

                            {/* Password */}
                            <label style={labelStyle}>🔑 Password</label>
                            <input
                                type="password" name="password" required id="password"
                                data-minlength="6" minLength={6}
                                onChange={this.onChange} value={this.state.password}
                                placeholder="Enter password"
                                style={{ ...(errors.password ? inputErrorStyle : inputStyle), marginBottom: 4 }}
                            />
                            <div style={helpTextStyle}>Minimum of 6 characters</div>

                            {/* Confirm password */}
                            <label style={{ ...labelStyle, marginTop: 16 }}>🔁 Confirm Password</label>
                            <input
                                type="password" name="password2" required id="password2"
                                onChange={this.onChange} value={this.state.password2}
                                placeholder="Re-enter password"
                                style={{ ...(errors.password2 ? inputErrorStyle : inputStyle), marginBottom: 16 }}
                            />

                            {/* Terms */}
                            <label style={{
                                display: "flex", alignItems: "flex-start", gap: 10,
                                color: errors.terms ? "#ff8a8a" : "#9ab3bd",
                                fontSize: 12, marginBottom: 20, cursor: "pointer",
                                lineHeight: 1.5,
                            }}>
                                <input
                                    id="checkbox_2" required type="checkbox"
                                    checked={this.state.terms}
                                    onChange={this.termsClick}
                                    style={{ width: 14, height: 14, accentColor: "#2eaabb", cursor: "pointer", marginTop: 2 }}
                                />
                                <span>
                                    I agree to all{" "}
                                    <a href="#" data-toggle="modal" data-target="#terms"
                                       style={{ color: "#2eaabb", textDecoration: "none", fontWeight: 600 }}>
                                        Terms &amp; Conditions
                                    </a>
                                </span>
                            </label>

                            {/* Submit */}
                            <button
                                type="submit"
                                style={{
                                    width: "100%", height: 46, fontSize: 14, fontWeight: 700,
                                    background: "linear-gradient(90deg,#1e8449,#27ae60)",
                                    border: "none", borderRadius: 10,
                                    color: "#fff", cursor: "pointer",
                                    letterSpacing: "0.6px", textTransform: "uppercase",
                                    boxShadow: "0 6px 18px rgba(39,174,96,0.35)",
                                    transition: "transform 0.1s, box-shadow 0.2s",
                                }}
                            >
                                🩺 Sign Up
                            </button>
                        </form>

                        {/* Footer link */}
                        <div style={{
                            textAlign: "center", padding: "12px",
                            background: "#0c2e32", borderTop: "1px solid rgba(46,170,187,0.18)",
                        }}>
                            <span style={{ color: "#5a8fa8", fontSize: 12 }}>Already have an account? </span>
                            <a href="/login" style={{ color: "#2eaabb", fontSize: 12, fontWeight: 600, textDecoration: "none" }}>
                                Sign in
                            </a>
                        </div>
                    </div>
                </div>

                {/* ─────────────────────────────────────────────────────────
                   Bootstrap modals (Terms / Cookies / Privacy) — kept
                   as-is. They use data-toggle / data-target wired to the
                   "Terms & Conditions" link above. Bootstrap JS handles
                   the show/hide; CSS is themed by the global stylesheet.
                ───────────────────────────────────────────────────────── */}
                <div className="modal fade" id="terms" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-scrollable" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <center>
                                    <h3 className="modal-title" id="myModalLabel">TERMS AND CONDITIONS</h3>
                                </center>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <p className="termsP">Welcome to Biocalculus! We recommend you to have a careful read on our TERMS AND CONDITIONS to use our Website, Product and Services.</p>
                                <p className="termsP">MAKE SURE YOU READ AND UNDERSTAND THE TERMS AND CONDITIONS COMPREHENSIVELY. THE TERMS AND CONDITIONS MENTIONED BELOW ADMINISTER THE VISITORS (‘YOU’) ON HOW TO FOLLOW TO THE RULES GOVERNING THE WEBSITE. THE WEBSITE IS OWNED AND SUPPORTED BY WAFERCHIPS TECHNO SOLUTIONS PVT LTD. (“WE”, “US”, “OUR”).</p>
                                <p className="termsP">BY VISITING THE WEBSITE AND USING ITS SERVICES, YOU AGREE TO CONFORM TO THE TERMS AND ARE BOUND BY THE CONDITIONS. IF YOU DISAGREE, PLEASE DO NOT USE THE WEBSITE ANY LONGER. THESE TERMS DO NOT APPLY TO ANY OTHER WEBSITES.</p>
                                <p className="termsP">THIS STATEMENT WAS DRAFTED ON 02 APRIL 2019 AND WAS LAST UPDATED ON 27 MAY 2019. WE ADVISE YOU TO REVIEW AND UNDERSTAND THE LATEST VERSION OF TERMS AND CONDITIONS EACH TIME YOU MAKE A VISIT TO THE WEBSITE OR USE ANY OF OUR SERVICES.</p>
                                <p>THIS WEBSITES USES COOKIES. TO KNOW FURTHER, READ
                                    <a href="#" data-toggle="modal" data-target="#cookiepolicy"><span className="txt-primary"> OUR COOKIE POLICY</span></a>
                                </p>
                                <h4>USER CONTENT</h4>
                                <p className="termsP">THE INFORMATION ON THE WEBSITE CONSTITUTES THE INFORMATION UPLOADED BY ITS USERS ALONG WITH DETAILED INFORMATION ON OUR PRODUCTS AND SERVICES WHICH BENEFITS OUR USERS. THE RESOURCES ON THE PAGES ARE LISTED ONLY FOR EDUCATIONAL PURPOSE. NO FINAL CONCLUSION SHOULD BE DRAWN FROM THEM. IT IS ADVISED TO CONSULT YOUR HEALTHCARE PHYSICIAN TO HAVE A COGNITIVE ANALYSIS. NEVER TAKE ANY INFORMATION ON THE WEBSITE AS A SUBSTITUTE FOR YOUR PHYSICIAN’S VIEW. YOUR DIAGNOSIS AND TREATMENT MUST BE BASED ON CONCLUSIONS VERIFIED BY YOUR PRACTITIONER.</p>
                                <h4>INFORMATION ON THE WEBSITE</h4>
                                <p className="termsP">THE INFORMATION YOU SUBMIT ON THE WEBSITE IN THE FORM OF TEXT, IMAGE, AUDIO OR VIDEO IS LABELED AS USER CONTENT. YOUR QUERIES, COMMENTS AND FEEDBACKS WILL ALSO BE CONSIDERED SO. ANY SPECIFIC INFORMATION YOU PROVIDE MUST BE ACCURATE AND UP-TO-DATE. YOU ARE NOT ALLOWED TO SHARE ANY DATA THAT IS ILLEGAL, OFFENSIVE OR HARASSING. BY AGREEING TO THE TERMS AND CONDITIONS, YOU GRANT BIOCALCULUS WORLDWIDE, ABSOLUTE, ROYALTY-FREE, IRREVOCABLE LICENSE TO USE, MODIFY, TRANSMIT, REPRODUCE, AND DISTRIBUTE DATA (OTHER THAN CLASSIFIED AS PERSONAL DATA IN
                                    <a href="#" data-toggle="modal" data-target="#privacypolicy"><span className="txt-primary"> PRIVACY POLICY</span></a>) AND ALSO AGREE WE ARE FREE TO USE THEM FOR ANY PURPOSE.
                                </p>
                                <h4>REGISTRATION AND PASSWORDS</h4>
                                <p className="termsP">IN ORDER TO GAIN ACCESS TO FULL CONTENT ON THE WEBSITE, YOU MUST REGISTER AND CREATE AN ACCOUNT FOR WHICH YOU WILL BE ASKED TO PROVIDE YOUR PERSONAL DETAILS. ONLY VALID DETAILS MUST BE ENTERED. A PASSWORD IS REQUIRED TO COMPLETE THE REGISTRATION PROCESS. WE ARE NOT RESPONSIBLE FOR ANY ACTIVITIES UNDER YOUR ACCOUNT. CONFIDENTIALITY OF THE PASSWORD IS TO BE MAINTAINED BY THE USER.</p>
                                <h4>USER RESTRICTION</h4>
                                <p className="termsP">THE WEBSITE IS NOT DESIGNATED TO BE OPERATED BY CHILDREN UNDER THE AGE OF 18 YEARS. BY VISITING THE WEBSITE AND USING OUR SERVICES, YOU AGREE TO BE 18 YEARS OF AGE. IF NOT, PLEASE RESTRICT YOURSELVES FROM FURTHER USAGE.</p>
                                <h4>COPYRIGHTS AND TRADEMARKS</h4>
                                <p className="termsP">ALL RIGHTS RELATED TO THE CONTENT IN THE WEBSITE LIES WITH THE COMPANY. WE OWN THE LABELS AND NAMES USED FOR OUR PRODUCTS AND SERVICES. ALL OUR CONTENT IS COPYRIGHTED UNDER THE COPYRIGHT ACT, 1957. YOU ARE NOT ALLOWED TO COPY, ALTER OR PUBLISH ANY CONTENT IN THIS WEBSITE ON AN ALIEN PLATFORM. DOWNLOADING THE BROCHURE AND LEAFLETS FOR PERSONAL USE IS ALLOWED. YOU ARE BOUND TO DOWNLOAD THE CONTENT ALONG WITH COPYRIGHTS STATEMENTS ONLY. IF FOUND WITH USAGE OF ANY TRADEMARKS AS MENTIONED AGAINST THE TERMS AND CONDITIONS, IT IS DULY NOTED AS A VIOLATION AND CAN INVOLVE LEGAL CHARGES.</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary btn-rounded" data-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="cookiepolicy" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-scrollable" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <center>
                                    <h3 className="modal-title" id="myModalLabel">Cookie policy</h3>
                                </center>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <p className="termsP">Cookie policy tells you how the website of Biocalculus uses cookies and your consent on cookie policy.</p>
                                <p className="termsP">Cookies are text files placed in the browser files of your computer when you visit. The cookies may be stored on your computer. Cookies permit to access limited information to recognize your devices and the choices you make while browsing through the website which can customize your experience. They collect only non personal information. You can always control the cookies. You are free to delete or block the cookies by adjusting the settings of your web browser, but please note that some parts of our website might not functioning effectively when you do so.</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary btn-rounded" data-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="privacypolicy" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-scrollable" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <center>
                                    <h3 className="modal-title" id="myModalLabel">PRIVACY STATEMENT</h3>
                                </center>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <p className="termsP">Welcome to Biocalculus! We recommend you to have a careful read on our privacy statement.</p>
                                <p className="termsP">We understand that privacy is important to you. Your privacy and trust is important to us. This privacy statement (“policy”) provides you information on how Biocalculus (“we”, “us”, “our”) collects, handles and uses information we gather from the Biocalculus devices.</p>
                                <p className="termsP">The information we collect is used to improve or enhance user experience and in working towards providing a customized usage to the customer.</p>
                                <h4>Introduction</h4>
                                <p className="termsP">The privacy statement describes how we use, protect, store and share the information gathered as you benefit from the services of Biocalculus through our website, device and mobile application. By using this website, you agree to the terms of the website.</p>
                                <p className="termsP"><i>Personal Information:</i> Any information that is related directly to your identity such as name, e-mail address, contact number, gender, height, weight and birth date which you voluntarily provide while you fill up any forms available in the website.</p>
                                <p className="termsP">No personal information will be collected if you only browse through the website.</p>
                                <p className="termsP"><i>Non Personal Information:</i> Non-personal information does not specifically reveal your identity. It may consist of information collected from your web browser, the internet domain or the date and time of access of website.</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary btn-rounded" data-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

SignUp.propTypes = {
    registerUser: PropTypes.func.isRequired,
    auth:         PropTypes.object.isRequired,
    errors:       PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
    auth:   state.auth,
    errors: state.errors,
});

export default connect(mapStateToProps, { registerUser })(withRouter(SignUp));
